import { useEffect, useMemo } from 'react';
import { useMap } from '@vis.gl/react-google-maps';
import { GoogleMapsOverlay } from '@deck.gl/google-maps';

// Bridges deck.gl layers onto a Google Maps instance managed by
// @vis.gl/react-google-maps. Renders nothing itself; it attaches a
// GoogleMapsOverlay to the map and keeps its layers in sync.
const DeckGlOverlay = ({ layers }) => {
  const overlay = useMemo(() => new GoogleMapsOverlay({ interleaved: true }), []);
  const map = useMap();

  useEffect(() => {
    overlay.setMap(map);

    return () => overlay.setMap(null);
  }, [overlay, map]);

  useEffect(() => {
    overlay.setProps({ layers });
  }, [overlay, layers]);

  return null;
};

export default DeckGlOverlay;
